module.exports = __webpack_public_path__ + "img/82.e3f4734a.jpg";